<template>
  <div>
    <v-card class="barcode-dialog" elevation="8">
      <v-card-title class="dialog-title">
        <h4 class="text-h5 font-weight-semibold">Edit Barcode Identifiers</h4>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="dialog-content">
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="identifiers"
                chips
                clearable
                multiple
                filled
                rounded
                append-icon=""
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    small
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(item)"
                  >
                    {{ item }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn text @click="toggleDialog">Cancel</v-btn>
        <v-btn color="primary" @click="saveChanges">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
    import axios from 'axios'

    // @group EditClient
    // Table to edit client barcodes on EditClientPage
    export default {
        name: "ClientBarcodes",
        props: {
            // Array of barcodes of the client
            clientBarcode: Array,
            // Function that toggles dialog in which are the barcodes
            toggleDialog: Function,
            // Client_id (number)
            id: Number,
        },
        data() {
            return {
              identifiers: this.clientBarcode,
            }
        },
        methods: {
            remove(value) {
              this.identifiers = this.identifiers.filter(item => item !== value)
            },
            saveChanges() {
              this.$emit('update:identifiers', this.identifiers)
              this.toggleDialog()
            },
        },
        computed: {
            // @vuese
            // Rendered Pricing array that will be displayed in the data-table (filtered by chosen region)
            // @type Array
            editPermission() {
                return this.$store.getters['auth/hasPermission']('client_edit');
            },
        }
    }
</script>

<style scoped>
.barcode-dialog {
  border-radius: 8px;
}

.dialog-title {
  padding: 32px 32px 16px;
}

.dialog-title h4 {
  margin: 0;
  color: #1A1A1A;
}

.dialog-content {
  padding: 24px 32px;
}

.dialog-actions {
  padding: 16px 32px 32px;
  justify-content: flex-end;
  gap: 16px;
}

.dialog-actions .v-btn {
  text-transform: none;
  font-weight: 600;
  min-width: 100px;
  height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientBarcodes.vue